import * as React from 'react';

import { AUTO_CLOSE_ONBOARDING_DELAY_MS, SHOW_ONBOARDING_DELAY_MS } from '../constants/compare';

interface IUseCompareFlightOnboardingResult {
  open: boolean;
  closeHandler(): void;
}

export function useCompareFlightOnboarding(enabled: boolean): IUseCompareFlightOnboardingResult {
  const [open, setOpen] = React.useState(false);

  const closeHandler = React.useCallback(() => {
    setOpen(false);
  }, []);

  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    const timerId = setTimeout(() => setOpen(true), SHOW_ONBOARDING_DELAY_MS);

    return () => clearTimeout(timerId);
  }, [enabled]);

  React.useEffect(() => {
    if (!open) {
      return;
    }

    const timerId = setTimeout(closeHandler, AUTO_CLOSE_ONBOARDING_DELAY_MS);
    const closeByDocumentClick = () => closeHandler();

    document.addEventListener('click', closeByDocumentClick);

    return () => {
      clearTimeout(timerId);
      document.removeEventListener('click', closeByDocumentClick);
    };
  }, [closeHandler, open]);

  return { open, closeHandler };
}
